import React from 'react';
import { CONTACT, IMAGES, LINKS } from '../data/site';
const GROUPS = [{
  title: 'Catalog',
  links: [{
    name: 'Shop all tools',
    href: LINKS.shopAll
  }, {
    name: 'Hand Tools',
    href: LINKS.handTools
  }, {
    name: 'English Wheels',
    href: LINKS.englishWheels
  }, {
    name: 'Sheet Metal Machines',
    href: LINKS.sheetMetalMachines
  }, {
    name: 'Gas Welding',
    href: LINKS.gasWelding
  }, {
    name: 'Metal Finishing',
    href: LINKS.finishing
  }, {
    name: 'ECKOLD',
    href: LINKS.eckold
  }, {
    name: 'Punch & Flare Tools',
    href: LINKS.punchFlare
  }]
}, {
  title: 'Training',
  links: [{
    name: 'Workshops',
    href: LINKS.workshops
  }, {
    name: 'Private training',
    href: LINKS.privateTraining
  }, {
    name: 'Books & DVDs',
    href: LINKS.booksDvds
  }, {
    name: 'Customer stories',
    href: LINKS.testimonials
  }]
}, {
  title: 'Company',
  links: [{
    name: 'Our story',
    href: LINKS.story
  }, {
    name: 'Custom fabrication',
    href: LINKS.fabrication
  }, {
    name: 'Contact',
    href: LINKS.contact
  }, {
    name: 'Gift certificates',
    href: LINKS.giftCertificates
  }]
}, {
  title: 'Information',
  links: [{
    name: 'FAQ',
    href: LINKS.faq
  }, {
    name: 'Shop terms & policies',
    href: LINKS.terms
  }, {
    name: 'Sales & specials',
    href: LINKS.specials
  }]
}];
export function Footer() {
  return <footer className="bg-charcoal text-steel-200" data-id="element-134" data-mp="828oa9xiabb9">
      <div className="mx-auto max-w-[1240px] px-5 py-14 sm:px-8" data-id="element-135" data-mp="80xik4ki2thi">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,2.2fr)] lg:gap-16" data-id="element-136" data-mp="335u5kj2dpi2">
          <div data-id="element-137" data-mp="hrif7mgm5nxs">
            <img src={IMAGES.logo} width={400} height={259} loading="lazy" alt="Fournier Enterprises" className="h-[84px] w-auto bg-white p-2" data-id="element-138" data-mp="hsa8urqnhblf" />
            <address className="mt-5 not-italic text-[15px] leading-relaxed" data-id="element-139" data-mp="ms6gr22gxn69">
              {CONTACT.addressLine1}
              <br data-id="element-140" data-mp="tvmp5eeoaakb" />
              {CONTACT.addressLine2}
              <br data-id="element-141" data-mp="tt09ssljiqrj" />
              <a href={CONTACT.phoneHref} className="mt-2 inline-flex min-h-[44px] items-center font-medium text-white transition-colors duration-150 ease-out hover:text-fred" data-id="element-142" data-mp="yu7ictvibtz9">
                {CONTACT.phoneLabel}
              </a>
              <br data-id="element-143" data-mp="18m3s526yh8jb" />
              <a href={`mailto:${CONTACT.email}`} className="inline-flex min-h-[44px] items-center transition-colors duration-150 ease-out hover:text-fred" data-id="element-144" data-mp="1clmbhtj4pbk1">
                {CONTACT.email}
              </a>
            </address>
          </div>

          <div className="grid grid-cols-2 gap-x-6 gap-y-8 lg:grid-cols-4" data-id="element-145" data-mp="1mhxmmg6zfvcw">
            {GROUPS.map(group => <nav key={group.title} aria-label={group.title} data-id="element-146" data-mp="3obevtoarh49r">
                <h2 className="font-display text-[13px] uppercase tracking-eyebrow text-fred" data-id="element-147" data-mp="3od841810vwjv">
                  {group.title}
                </h2>
                <ul className="mt-4 space-y-1" data-id="element-148" data-mp="2afdj5evzdcpu">
                  {group.links.map(link => <li key={link.name} data-id="element-149" data-mp="25nvlazp97s93">
                      <a href={link.href} className="flex min-h-[44px] items-center text-[15px] transition-colors duration-150 ease-out hover:text-white" data-id="element-150" data-mp="25n3wq8u2qusb">
                        {link.name}
                      </a>
                    </li>)}
                </ul>
              </nav>)}
          </div>
        </div>

        <p className="mt-12 border-t border-white/10 pt-6 text-[13px] text-steel-400" data-id="element-151" data-mp="2pa9wu7mk6sab">
          © 2026 Fournier Enterprises II, LLC. Mt. Clemens, Michigan.
        </p>
      </div>
    </footer>;
}